import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { devURL } from "../constants/constants";
import RaportQuery from "../components/raport/RaportQuery";
import RaportTitleFromTo from "../components/raport/RaportTitleFromTo";
import RaportTotal from "../components/raport/RaportTotal";
import RaportProducts from "../components/raport/RaportProducts";
import Loading from "../components/global/Loading";

import '../styles/raport-page.css';

export default function Raports() {
    const { search } = useLocation();
    const now = new Date();
    const prev_date = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - 1,
        23,
        59,
        0
    );

    const url_query = new URLSearchParams(search);
    const station = url_query.get("station") || '';
    const dateFrom = url_query.get("day") || '';
    const dateTo = url_query.get("dateTo") || prev_date.toISOString(); 

    const [ query, setQuery ] = useState({
        station,
        dateFrom,
        dateTo
    });
    const [ data, setData ] = useState(null);

    useEffect(() => {
        async function getData() {
            try {
                setData(null);
                await axios({
                    method: 'get',                    
                    url: `${devURL}/live-sales?station=${query.station}&date=${query.dateFrom}&dateTo=${query.dateTo}`
                }).then(response => setData(response.data))
            } catch(error) {
                console.log(error)
            }
        };
        getData();
    }, [query] );

    return (
        <div className="raport-page">
            <RaportQuery query={query} setQuery={setQuery}/>
            { 
                !data ? <Loading/> : 
                <>
                    <RaportTitleFromTo station={query.station[0]} dateFrom={query.dateFrom} dateTo={query.dateTo}/>
                    <RaportTotal data={data[0].today.total}/>
                    <RaportProducts data={data[0].today.products}/> 
                </>
            }

        </div>
    )
}